import { Component, OnInit } from '@angular/core';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';

@Component({
  selector: 'app-navbar-menu-toggle-button',
  templateUrl: './navbar-menu-toggle-button.component.html',
  styleUrls: ['./navbar-menu-toggle-button.component.scss']
})
export class NavbarMenuToggleButtonComponent implements OnInit {

  constructor(
    public sidebarService: StateSidebarService
  ) { }

  ngOnInit() {
  }

  public toggleSidebarState() {

  }

}
